<template>
    <div class="store-info">
        <div class="info-s">
            <img class="store-img" :src="storeInfo.cover_image" alt="门店logo">
            <div class="info-s-text">
                <div class="info-s-name">{{storeInfo.name}}</div>
                <div class="info-tips">
                    <div class="tips-c" v-for="(item, index) in tips" :key="'tips' + index">
                        <img class="tips-img" src="@/assets/trues.png" alt="门店logo">
                        <span class="tips-text">{{item}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="store-a-s">
            <div>
                <img class="store-a-img" src="@/assets/ardss.png" alt="门店logo">
                <div class="store-text">地址</div>
            </div>
            <div style="margin-left: 20px;">
                <img class="store-a-img" src="@/assets/phone.png" alt="门店logo">
                <div class="store-text">电话</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    // 门店信息
    name: 'StoreInfo',
    props: {
        storeInfo: {
            type: Object,
            default: () => {},
            required: false
        }
    },
    data() {
        return {
            tips: [ '实体认证','卫生认证', '卫生认证' ]
        }
    },
    created() {

    },
    methods: {

    },

    mounted() {

    },
}
</script>

<style>
    .store-info {
        background: #fff;
        padding: 12px 16px;
        display: flex;
        position: relative;
    }

    .info-s {
        display: flex;
    }

    .store-img {
        width: 56px;
        height: 56px;
        border-radius: 50%;
    }

    .info-s-text {
        margin-left: 8px;
    }

    .info-s-name {
        font-size: 16px;
        margin-top: 4px;
    }

    .info-tips {
        display: flex;
        margin-top: 5px;
    }

    .tips-c {
        margin-right: 8px;
    }

    .tips-img {
        width: 16px;
        height: 16px;
        vertical-align: middle;
    }

    .tips-text {
        font-size: 10px;
        color: #666666;
        margin-left: 1px;
        vertical-align: middle;
    }

    .store-a-s {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
    }

    .store-a-img {
        width: 20px;
        height: 20px;
    }

    .store-text {
        font-size: 10px;
        color: #666666;
    }
</style>
